export default {"src":"/_next/static/image/public/img/info-circle.dea24ba4c41cb5ac8455b0f49545cdf7.svg","height":192,"width":192};